import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HkVlSelectComponent } from './hk-vl-select.component';



@NgModule({
  declarations: [
    HkVlSelectComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HkVlSelectComponent
  ]
})
export class HkVlSelectModule { }
